import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { withStyles, Tabs, Tab, Typography, AppBar, Badge } from '@material-ui/core';
import { Logger } from 'data/common';

function TabContainer(props) {
    const { children } = props;
    return (
        <Typography component="div" style={{ padding: 8 * 3 }}>
            {children}
        </Typography>
    );
}

TabContainer.propTypes = {
    children: PropTypes.node.isRequired
};

class Index extends PureComponent {
    static propTypes = {
        history: PropTypes.object.isRequired,
        theme: PropTypes.object.isRequired,
        tabList: PropTypes.object.isRequired,
        environment: PropTypes.string.isRequired,
        classes: PropTypes.object.isRequired
    };

    state = { currentTab: 0 };

    static getDerivedStateFromProps(nextProps, prevState) {
        let path = nextProps.location.pathname.split('/')[2];
        let entry = prevState.currentTab;

        nextProps.tabList.map(tab => {
            if (tab.path === path) entry = tab.key;
        });

        if (entry !== prevState.currentTab) return { currentTab: entry };
        return null;
    }

    handleChange = (event, currentTab) => {
        this.setState({ currentTab });
    };

    handleClick = tab => {
        const { history, environment } = this.props;
        Logger.verbose(`Redirect to ${tab}`);
        return history.push(`/${environment}/${tab}`);
    };

    render() {
        const { tabList, theme, classes } = this.props;
        const { currentTab } = this.state;

        return (
            <div className={classes.subMenuFixedDiv}>
                <div className={classes.subMenuContainer}>
                    <div className="subMenu">
                        <AppBar position="static" color="inherit" style={{ backgroundColor: theme.palette.text.contrastText }}>
                            <Tabs
                                value={currentTab}
                                onChange={this.handleChange}
                                variant="scrollable"
                                scrollButtons="on"
                                indicatorColor="primary"
                                textColor="primary"
                                classes={{
                                    scrollButtons: `${classes.scrollButtons} _scrollButton`,
                                    flexContainer: classes.flexContainer,
                                    scroller: classes.scroller,
                                    root: classes.root
                                }}
                            >
                                {tabList.valueSeq().map((tab, i) => {
                                    let icon = null;

                                    if (tab.Png) icon = <img src={tab.Png} alt={tab.label} className={classes.pngIcon} />;
                                    else icon = <tab.Icon color={theme.palette.primary.main} size={30} />;

                                    if (typeof tab.badge === 'number') {
                                        let subIcon = icon;

                                        icon = (
                                            <Badge color="secondary" badgeContent={tab.badge} showZero classes={{ badge: classes.badge }}>
                                                {subIcon}
                                            </Badge>
                                        );
                                    }

                                    return (
                                        <Tab
                                            key={i}
                                            value={tab.key}
                                            icon={icon}
                                            label={tab.label}
                                            onClick={this.handleClick.bind(this, tab.path)}
                                            classes={{ wrapper: classes.wrapper }}
                                        />
                                    );
                                })}
                            </Tabs>
                        </AppBar>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps() {
    return {};
}

const styles = theme => ({
    subMenuFixedDiv: {
        position: 'fixed',
        width: '100%',
        zIndex: 15
    },
    subMenuContainer: {
        transition: 'margin-top 0.2s ease-in-out',
        marginTop: 38,
        maxWidth: '100vw',
        '& ._scrollButton': {
            transition: 'all 0.2s ease-in-out'
        },
        '&:hover': {
            transition: 'margin-top 0.2s ease-in-out',
            marginTop: 64,
            '& ._scrollButton': {
                transition: 'all 0.2s ease-in-out',
                marginTop: 0
            }
        },
        [theme.breakpoints.down('xs')]: {
            marginTop: 50,
            '& ._scrollButton': {
                transition: 'all 0.2s ease-in-out',
                marginTop: 0
            },
            '&:hover': {
                marginTop: 50,
                '& ._scrollButton': {
                    transition: 'all 0.2s ease-in-out',
                    marginTop: 0
                }
            }
        }
    },
    scrollButtons: {
        marginTop: 30
    },
    flexContainer: {
        margin: '0 auto'
    },
    root: {
        margin: '0 auto',
        maxWidth: '100vw'
    },
    pngIcon: {
        width: 40,
        height: 40,
        WebkitBoxShadow: '0px 0px 2px 0px rgba(0,0,0,0.50)',
        borderRadius: 6
    },
    badge: {
        marginTop: 10,
        marginRight: -10
    },
    wrapper: {
        flexDirection: 'column-reverse'
    }
});

export default withRouter(connect(mapStateToProps)(withStyles(styles, { withTheme: true })(Index)));



// WEBPACK FOOTER //
// ./data/components/SubMenu.js